module.exports = __webpack_public_path__ + "static/media/jackpot-history.8b8bd8ba.svg";